
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { style } from './style';
import queryString from 'query-string';
import {isJsonString} from '../../utils/setting'
import QRCode from 'qrcode.react';

class QRCodeComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            qrCodeValue: '',
            qrcodeSize: 170
        };
    }

    async componentDidMount() { 
        const parsed = queryString.parse(this.props.location.search);
        let serviceCode = parsed.serviceCode
        let size = parsed.size
        let result = await this.props.getInfoQRcode({serviceCode})
        if(result.code === 1) {
            let qrcode = isJsonString(result.data.qrcode) ? JSON.parse(result.data.qrcode) : {
                serviceCode: '',
                serviceName: '',
                website: '',
                mobile: ''
            }
            let qrCodeValue = `${qrcode.serviceCode} ${qrcode.serviceName} ${qrcode.website} ${qrcode.mobile}`
            this.setState({qrCodeValue: qrCodeValue, qrcodeSize: size})
        }
    }
    render() {
        const {classes} = this.props
        let {qrCodeValue, qrcodeSize} = this.state
        return (
        <div className = {classes.container}>
            <QRCode
              id= 'qrcodeCavas'
              value={qrCodeValue}
              size={qrcodeSize.toString()}
              fgColor='#000000'
              bgColor='#ffffff'
              level='L'
              imageSettings = {{
                  src: 'https://static.zpao.com/favicon.png',
                  x: null,
                  y: null,
                  height: 24,
                  width: 24,
                  excavate: true,
              }} 
              // renderAs='svg'
          />
        </div>
        )
    }
} 
const mapState = state => ({

});

const mapDispatch = dispatch => ({
    getInfoQRcode: dispatch.service.getInfoQRcode
});

export default connect(mapState, mapDispatch)(translate('translations')(withStyles(style, { withTheme: true })(QRCodeComponent)));
